import React from 'react';
import PropTypes from 'prop-types';
import {flushSync} from 'react-dom';
import ImageCropperModal from 'common/components/image-cropper-modal';
import classNames from 'classnames';
import {t} from 'common/utils/translation-util';
import {injectReactElement, unmountReactElement} from 'common/utils/dom-util';

export default class ImageCropper extends React.Component {
  static propTypes = {
    border: PropTypes.number,
    buttonText: PropTypes.string,
    className: PropTypes.string,
    croppedImageSrc: PropTypes.string,
    defaultImageSrc: PropTypes.string,
    disableCrop: PropTypes.bool,
    errorMessage: PropTypes.any,
    fieldLabel: PropTypes.string,
    fileFieldId: PropTypes.string.isRequired,
    height: PropTypes.number,
    helpMessage: PropTypes.string,
    isOptional: PropTypes.bool,
    modalId: PropTypes.string,
    modalTitle: PropTypes.string,
    modalTriggerTitle: PropTypes.string,
    originalImageSrc: PropTypes.string,
    showOriginalImage: PropTypes.bool,
    tooltipText: PropTypes.string,
    width: PropTypes.number,
  };

  static defaultProps = {
    buttonText: t('Upload a photo'),
    helpMessage: t('At least 500x500 pixels is recommended.'),
    isOptional: false,
    modalId: '',
  };

  constructor(props, context) {
    super(props, context);

    this.cancel = this.cancel.bind(this);
    this.clearImage = this.clearImage.bind(this);
    this.crop = this.crop.bind(this);
    this.onFileChange = this.onFileChange.bind(this);
    this.openFileDialog = this.openFileDialog.bind(this);
    this.showModal = this.showModal.bind(this);

    this.state = {
      image: props.originalImageSrc,
      imagePreview:
        props.croppedImageSrc ||
        props.originalImageSrc ||
        props.defaultImageSrc,
      clear: false,
    };
  }

  UNSAFE_componentWillMount() {
    this.fileField = $(`#${this.props.fileFieldId}`);
    this.fileField.hide();
    this.fileField.on('change', this.onFileChange);
  }

  cancel() {}

  crop() {
    const {showOriginalImage} = this.props;
    const {x, y, width, height} = this.modal.avatar.getCroppingRect();
    $('input[name=cropX]').val(x);
    $('input[name=cropY]').val(y);
    $('input[name=cropWidth]').val(width);
    $('input[name=cropHeight]').val(height);

    const imagePreview = showOriginalImage
      ? this.state.image
      : this.modal.avatar.getImage().toDataURL();
    this.setState({imagePreview});
  }

  openFileDialog() {
    this.fileField.click();
  }

  showModal(event) {
    if (this.props.disableCrop) {
      return;
    }

    event?.preventDefault();

    injectReactElement(
      document.getElementById(this.props.modalId),
      <ImageCropperModal
        image={this.state.image}
        onCancel={this.cancel}
        onOK={this.crop}
        ref={(_modal) => (this.modal = _modal)}
      />,
    );
    $(`#${this.props.modalId}`).modal('show');
  }

  unmountModal() {
    if (this.props.disableCrop) {
      return;
    }
    unmountReactElement(document.getElementById(this.props.modalId));
  }

  clearImage() {
    this.setState({
      image: null,
      imagePreview: null,
      clear: true,
    });
    this.fileField.val('');
  }

  render() {
    const cropButton = (
      <a
        className='btn'
        href={`#${this.props.modalId}`}
        onClick={this.showModal}>
        <i className='fa-camera fa-lg-button' />{' '}
        {this.props.modalTriggerTitle || t('Crop...')}
      </a>
    );
    const clearStyles = {
      float: 'none',
      fontSize: '30px',
      marginLeft: '10px',
      verticalAlign: 'middle',
    };
    const canClear =
      this.state.image && !this.state.image.includes('/default_avatars/');
    // emulate default django behavior for clearing ImageField
    // https://docs.djangoproject.com/en/1.10/_modules/django/forms/widgets/#ClearableFileInput

    const clearName = `${this.fileField.prop('name')}-clear`;
    return (
      <div className={classNames('control-group', this.props.className)}>
        <label className='control-label'>
          {this.props.tooltipText ? (
            <span
              className={'popover_top pull-right'}
              data-content={this.props.tooltipText}
              data-placement={'top'}
              rel={'popover'}>
              <i className={'fa-question-circle'} />
            </span>
          ) : null}
          <span className='label-text'>
            {this.props.fieldLabel}
            {this.props.isOptional ? (
              <div className={'FieldLabelOptional'}>{t('(optional)')}</div>
            ) : null}
          </span>
        </label>
        <div className='controls'>
          <div>
            <span className='btn' onClick={this.openFileDialog}>
              <i className='fa-camera fa-lg-button' /> {this.props.buttonText}
            </span>
            &nbsp;
            {!this.props.disableCrop && this.state.image ? cropButton : null}
          </div>
          <p className='help-block'>
            {this.props.errorMessage || this.props.helpMessage}
          </p>
          {this.state.imagePreview ? (
            <div>
              <a
                href={this.state.image}
                rel='noopener noreferrer'
                target='_blank'>
                <img
                  src={this.state.imagePreview}
                  style={{maxWidth: '100px'}}
                />
              </a>
              {canClear ? (
                <span
                  className='close fileupload-exists'
                  onClick={this.clearImage}
                  style={clearStyles}>
                  {'x'}
                </span>
              ) : null}
            </div>
          ) : null}
          {this.state.clear ? (
            <input
              checked={true}
              name={clearName}
              readOnly={true}
              style={{display: 'none'}}
              type='checkbox'
            />
          ) : null}
        </div>
      </div>
    );
  }

  onFileChange(event) {
    const file = event.target.files[0];
    if (!file || !file.type.match('image.*')) {
      return;
    }
    const reader = new FileReader();
    reader.onload = (ev) => {
      if (!this.props.disableCrop) {
        this.unmountModal();
      }
      const image = ev.target.result;
      flushSync(() => {
        this.setState({
          image,
          imagePreview: image,
          clear: false,
        });
      });
      if (!this.props.disableCrop) {
        this.showModal();
      }
    };
    reader.readAsDataURL(file);
  }
}
